import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomStorageFallbackService } from '../../services/DomStorageFallback.service';
import { AppUtility } from '../../utils/utility';

@Component({
    selector: 'al-select-datepicker',
    providers: [DomStorageFallbackService],
    template: `
		<label>
            <strong *ngIf='effectiveDateLabel'>{{effectiveDateLabel}}</strong>
            <small *ngIf='earliestTextLabel && effectiveDate'><span class='fwn'>({{earliestTextLabel}} {{effectiveDate}})</span></small>
        </label>
        <!-- Default -->
		<div *ngIf="formType === ''">
            <select id='months' [(ngModel)]='selectedMonthModel' [title]="ariaMonthTitle" #month (change)='getFullDate($event);'>
                <!--
                <ng-container *ngIf="showDefaultValue">
                <option [ngValue]='undefined' disabled>Month</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option [ngValue]='month' *ngFor='let month of months;let i= index; '>
                    {{ month }}
                </option>
            </select>

            <select id='days' #day [(ngModel)]='selectedDayModel' [title]="ariaDayTitle" (change)='getFullDate($event)'>
                <!--
                <ng-container *ngIf="showDefaultValue">
                <option [ngValue]='undefined' disabled>Day</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option *ngFor='let day of days' [ngValue]='day'>
                    {{ day }}
                </option>
            </select>

            <select id='years' [(ngModel)]='selectedYearModel' #year [title]="ariaYearTitle" (change)='getFullDate($event)'>
                <!--
                <ng-container *ngIf="showDefaultValue">
                <option [ngValue]='undefined' disabled>Year</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option [ngValue]='year' *ngFor='let year of years'>
                    {{ year }}
                </option>
            </select>

            <p-calendar styleClass='al-select-datepicker' [disabledDates]='_disabledDates' (onSelect)="getDateFromCalendar($event)" [minDate]='_minDateValue' [maxDate]='_maxDateValue' [(ngModel)]='dateValue' [ngModelOptions]="{ standalone: true}" dateFormat='{{formate}}' [showIcon]='true' (onSelect)='generate($event)' appendTo='body' showButtonBar='true' [inputStyle]="{'opacity':'0', 'width':'34px', 'height':'33px', 'position':'absolute', 'font-size':'0'}" [showOnFocus]="false" tabindex="-1" [locale]="labels"></p-calendar><br />
        </div>
		<!-- Model Driven Approach -->
        <div *ngIf="formType === 'MDF'" [formGroup]="parentFormDateWrapper">
            <select id='months' [title]="ariaMonthTitle" formControlName="selectedMonthModel" #month [(ngModel)]='selectedMonthModel' (change)='getFullDate($event);'>
                <!--
                <ng-container *ngIf="showDefaultValue">
                    <option [ngValue]='undefined' disabled>Month</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                    <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option [ngValue]="month" *ngFor='let month of months;let i= index; '>
                    {{ month }}
                </option>
            </select>

            <select id='days' [title]="ariaDayTitle" formControlName="selectedDayModel" #day [(ngModel)]='selectedDayModel' (change)='getFullDate($event)' >
                <!--
                <ng-container *ngIf="showDefaultValue">
                <option [ngValue]='undefined' disabled>Day</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option [ngValue]="day" *ngFor='let day of days'>
                    {{ day }}
                </option>
            </select>

            <select id='years' [title]="ariaYearTitle" formControlName="selectedYearModel" #year [(ngModel)]='selectedYearModel' (change)='getFullDate($event)'>
                <!--
                <ng-container *ngIf="showDefaultValue">
                <option [ngValue]='undefined' disabled>Year</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option [ngValue]="year" *ngFor='let year of years'>
                    {{ year }}
                </option>
            </select>

            <p-calendar styleClass='al-select-datepicker' [disabledDates]='_disabledDates' (onSelect)="getDateFromCalendar($event)" [minDate]='_minDateValue' [maxDate]='_maxDateValue' [(ngModel)]='dateValue' [ngModelOptions]="{ standalone: true}" dateFormat='{{formate}}' [showIcon]='true' (onSelect)='generate($event)' appendTo='body' showButtonBar='true' [inputStyle]="{'opacity':'0', 'width':'34px', 'height':'33px', 'position':'absolute', 'font-size':'0'}" [showOnFocus]="false" tabindex="-1" [locale]="labels"></p-calendar><br />
        </div>

		<!-- Form Builder Approach -->
		<div *ngIf="formType === 'FB'" [formGroup]="parentFormDateWrapper">
            <select id='months' [title]="ariaMonthTitle" formControlName="selectedMonth" [(ngModel)]='selectedMonthModel' #month (change)='getFullDate($event);'>
                <!--
                <ng-container *ngIf="showDefaultValue">
                <option [ngValue]='undefined' disabled>Month</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option [ngValue]="month" *ngFor='let month of months;let i= index; '>
                    {{ month }}
                </option>
            </select>

            <select id='days' formControlName="selectedDay" [title]="ariaDayTitle" [(ngModel)]='selectedDayModel' (change)='getFullDate($event)' #day>
                <!--
                <ng-container *ngIf="showDefaultValue">
                <option [ngValue]='undefined' disabled>Day</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option [ngValue]="day" *ngFor='let day of days'>
                    {{ day }}
                </option>
            </select>

            <select id='years' formControlName="selectedYear" [title]="ariaYearTitle" [(ngModel)]='selectedYearModel' #year (change)='getFullDate($event)'>
                <!--
                <ng-container *ngIf="showDefaultValue">
                <option [ngValue]='undefined' disabled>Year</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option [ngValue]="year" *ngFor='let year of years'>
                    {{ year }}
                </option>
            </select>

            <p-calendar styleClass='al-select-datepicker' [disabledDates]='_disabledDates' (onSelect)="getDateFromCalendar($event)" [minDate]='_minDateValue' [maxDate]='_maxDateValue' [(ngModel)]='dateValue' [ngModelOptions]="{ standalone: true}" dateFormat='{{formate}}' [showIcon]='true' (onSelect)='generate($event)' appendTo='body' showButtonBar='true' [inputStyle]="{'opacity':'0', 'width':'34px', 'height':'33px', 'position':'absolute', 'font-size':'0'}" [showOnFocus]="false" tabindex="-1" [locale]="labels"></p-calendar><br />
        </div>

		<!-- Template Driven Approach -->
		<div *ngIf="formType === 'TDF'">
            <select id='months' name="month" [title]="ariaMonthTitle" [(ngModel)]='selectedMonthModel' #month (change)='getFullDate($event);' [required]="requiredIf">
                <!--
                <ng-container *ngIf="showDefaultValue">
                    <option [ngValue]='undefined' disabled>Month</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                    <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option [ngValue]="month" *ngFor='let month of months;let i= index; '>
                    {{ month }}
                </option>
            </select>

            <select id='days' name="day" [title]="ariaDayTitle" [(ngModel)]='selectedDayModel' #day (change)='getFullDate($event)' [required]="requiredIf">
                <!--
                <ng-container *ngIf="showDefaultValue">
                <option [ngValue]='undefined' disabled>Day</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option [ngValue]="day" *ngFor='let day of days' [ngValue]='day'>
                    {{ day }}
                </option>
            </select>

            <select id='years' name="year" [(ngModel)]='selectedYearModel' [title]="ariaYearTitle" #year (change)='getFullDate($event)' [required]="requiredIf">
                <!--
                <ng-container *ngIf="showDefaultValue">
                <option [ngValue]='undefined' disabled>Year</option>
                </ng-container>
                <ng-container *ngIf="!showDefaultValue">
                <option [ngValue]='undefined' disabled></option>
                </ng-container>
                -->
                <option [ngValue]="year" *ngFor='let year of years'>
                    {{ year }}
                </option>
            </select>

            <p-calendar styleClass='al-select-datepicker' [disabledDates]='_disabledDates' (onSelect)="getDateFromCalendar($event)" [minDate]='_minDateValue' [maxDate]='_maxDateValue' [(ngModel)]='dateValue' dateFormat='{{formate}}' [showIcon]='true' (onSelect)='generate($event)' appendTo='body' showButtonBar='true' [inputStyle]="{'opacity':'0', 'width':'34px', 'height':'33px', 'position':'absolute', 'font-size':'0'}" [showOnFocus]="false" tabindex="-1" [locale]="labels"></p-calendar><br>

        </div>
  `
})
export class AlSelectDatepickerComponent implements OnInit, AfterViewInit {
    _maxDateValue: Date;
    _minDateValue: Date;
    _disabledDates: Date[] = [];
    _defaultDate: string | Date;
    years = [];
    months = [];
    days = [];
    selectedMonthModel;
    selectedYearModel;
    selectedDayModel;
    selectedMonthVal: number = 1;
    selectedYearVal: number = new Date().getFullYear();
    endYear: number = 2299;
    dateValue;
    labels: any;
    dateSelectorMultiLanguage: any;
    dateSelectorMultiLanguage_monthList: any;
    dateSelectorMultiLanguage_shortMonthList: any;

    @Input() formate = 'mm/dd/yy';
    @Input() effectiveDate: any = '';
    @Input() effectiveDateLabel: any = 'Effective Date';
    @Input() earliestTextLabel: any = 'Earliest';
    @Input() monthFullname = true;
    @Input() trimNum: number;
    @Input() parentFormDateWrapper: FormGroup;
    @Input() formType = '';
    @Input() ariaMonthTitle: string = 'Select Month';
    @Input() ariaDayTitle: string = 'Select Day';
    @Input() ariaYearTitle: string = 'Select Year';
    monthNmArr: any = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    monthIndex: any;
    /* istanbul ignore next */
    @Input()
    set minDateValue(value) {
        // DCH-3906 remove condition to set max date
        // if (new Date(value) >= new Date()) {
        //     this._minDateValue = new Date();
        // } else {
        this._minDateValue = new Date(value);
        // }
    }
    /* istanbul ignore next */
    @Input()
    set maxDateValue(value) {
        // DCH-3906 remove condition to set max date
        // if (new Date(value) <= new Date()) {
        //     this._maxDateValue = new Date();
        // } else {
        this._maxDateValue = new Date(value);
        // }
    }
    /* istanbul ignore next */
    @Input()
    set disabledDates(value) {
        if (value && value.length > 0) {
            for (let i = 0; i < value.length; i++) {
                this._disabledDates.push(new Date(value[i]));
            }
        }
    }

    // Set Default Date
    /* istanbul ignore next */
    @Input()
    set defaultDate(value: string | Date) {
        if (value) {
            this._defaultDate = (typeof value === 'string') ? new Date(value) : value;

            this.selectedYearModel = this._defaultDate.getFullYear();
            if (this.monthFullname) {
                let monthList = this.createMonthsList();
                this.selectedMonthModel = monthList[this._defaultDate.getMonth()];
            } else {
                let shortMonthsList = this.createShortMonthsList();
                this.selectedMonthModel = shortMonthsList[this._defaultDate.getMonth()];
            }
            this.selectedDayModel = this._defaultDate.getDate();

            // UFD-5296 : When Month, Date and year field is auto populated on component render or on page load then on click of Datepicker icon, it should show the same date selected which is populated in this three fields.
            if (this.selectedMonthModel && this.selectedDayModel && this.selectedYearModel) {
                this.dateValue = new Date(`${this.selectedMonthModel} ${this.selectedDayModel} ${this.selectedYearModel}`);
                // this.onDateChange.emit({ 'event': event || window.event, 'fulldate': this.dateValue });
            }
        }
    }

    @Output() onDateChange = new EventEmitter();

    @ViewChild('month', { static: false }) MonthRef: ElementRef;
    @ViewChild('day', { static: false }) DayRef: ElementRef;
    @ViewChild('year', { static: false }) YearRef: ElementRef;
    @Input() requiredIf;
    @Input() showDefaultValue = true;

    /* istanbul ignore next */
    constructor(private _elementRef: ElementRef, private domStorageFB: DomStorageFallbackService, private appUtility: AppUtility) { }

    /* istanbul ignore next */
    ngOnInit() {
        this.years = this.createYearsList();
        if (this.monthFullname) {
            this.months = this.createMonthsList();
        } else {
            this.months = this.createShortMonthsList();
        }
        this.days = this.checkDaysInMonth();
        // ----------------make date selector dynamic to pick language as per chane---------------

        if (this.domStorageFB.getItem('dateSelectorKey') !== null && this.domStorageFB.getItem('dateSelectorKey') !== '' && this.domStorageFB.getItem('dateSelectorKey') !== undefined) {
            this.dateSelectorMultiLanguage = JSON.parse(this.domStorageFB.getItem('dateSelectorKey'));
            this.labels = this.dateSelectorMultiLanguage;
        } else {
            this.labels = {
                firstDayOfWeek: 0,
                dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                today: 'Today',
                clear: 'None'
            };
        }
    }

    /* istanbul ignore next */
    ngAfterViewInit() {
        let monthsName, tempMonth;
        const getDatepickerTriggerButton = this._elementRef.nativeElement.querySelector('.ui-datepicker-trigger');
        getDatepickerTriggerButton.removeAttribute('tabindex');
        getDatepickerTriggerButton.classList.add('al-button-neutral');
        if (this.selectedMonthModel) {
            if (this.dateSelectorMultiLanguage_monthList) {
                monthsName = this.dateSelectorMultiLanguage_monthList.monthNames;
                let index = 0;
                for (const month of Object.keys(monthsName)) {
                    if (monthsName[month] === this.selectedMonthModel) {
                        this.monthIndex = index;
                    }
                    index++;
                }
            }
        }
        if (this.selectedMonthModel && this.selectedDayModel && this.selectedYearModel) {
            tempMonth = this.selectedMonthModel;
            if (this.monthIndex) {
                this.selectedMonthModel = this.retrieveMonthNames(this.monthIndex);
            }
            this.dateValue = new Date(`${this.selectedMonthModel} ${this.selectedDayModel} ${this.selectedYearModel}`);
            this.onDateChange.emit({ 'event': event || window.event, 'fulldate': this.dateValue });
            this.selectedMonthModel = tempMonth;
        }
    }

    // Years array
    /* istanbul ignore next */
    createYearsList() {
        let yearsList = [];
        let startYear = this.getEffectiveYear();

        if (this._maxDateValue) {
            this.endYear = this._maxDateValue.getFullYear();
        }

        while (startYear <= this.endYear) {
            yearsList.push(startYear++);
        }

        return yearsList;
    }

    // Months array
    /* istanbul ignore next */
    createMonthsList() {
        // let monthsName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        let monthsName: any;
        if (this.domStorageFB.getItem('dateSelectorKey') !== null && this.domStorageFB.getItem('dateSelectorKey') !== '' && this.domStorageFB.getItem('dateSelectorKey') !== undefined) {
            this.dateSelectorMultiLanguage_monthList = JSON.parse(this.domStorageFB.getItem('dateSelectorKey'));
            monthsName = this.dateSelectorMultiLanguage_monthList.monthNames;
        } else {
            monthsName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        }
        return monthsName;
    }

    // Months array
    /* istanbul ignore next */
    createShortMonthsList() {
        // let monthsName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
        let monthsName: any;
        if (this.domStorageFB.getItem('dateSelectorKey') !== null && this.domStorageFB.getItem('dateSelectorKey') !== '' && this.domStorageFB.getItem('dateSelectorKey') !== undefined) {
            this.dateSelectorMultiLanguage_shortMonthList = JSON.parse(this.domStorageFB.getItem('dateSelectorKey'));
            monthsName = this.dateSelectorMultiLanguage_shortMonthList.monthNamesShort;
        } else {
            monthsName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
        }
        return monthsName;
    }

    // Number of days in month based on year
    /* istanbul ignore next */
    createDaysList(month, year) {
        return new Date(year, month, 0).getDate();
    }

    // get final days list
    /* istanbul ignore next */
    checkDaysInMonth(event?) {
        let daysList = [];
        let i = 1;
        let days;

        if (this.selectedMonthModel && this.selectedYearModel) {
            days = this.createDaysList(this.selectedMonthVal, parseInt(this.selectedYearModel, 10));
        } else {
            days = this.createDaysList(this.selectedMonthVal, this.selectedYearVal);
        }

        while (i <= days) {
            daysList.push(i++);
        }

        return daysList;
    }

    // get selected month
    /* istanbul ignore next */
    getFullDate(event) {
        let tempMonth, dayExist = false;
        if (this.selectedMonthModel && this.selectedDayModel && this.selectedYearModel) {
            tempMonth = this.selectedMonthModel;
            if (this.appUtility.isPostAuth()) {
                this.monthIndex = this.handleMonthIndex(this.selectedMonthModel);
                this.selectedMonthModel = this.retrieveMonthNames(this.monthIndex);
            }
            this.dateValue = new Date(`${this.selectedMonthModel} ${this.selectedDayModel} ${this.selectedYearModel}`);
            this.onDateChange.emit({ 'event': event, 'fulldate': this.dateValue });
            this.selectedMonthModel = tempMonth;
        }

        if (!this.selectedDayModel) {
            this.selectedDayModel = 1;
        }
        this.days = this.checkDaysInMonth();

        if (event.target.id === 'months') {
            this.selectedMonthVal = event.target.selectedIndex + 1;
            // UFD-6596: issue fix, set day to 1 on month change
            for (const day of Object.keys(this.days)) {
                if (this.days[day] === this.selectedDayModel) {
                    dayExist = true;
                    break;
                }
            }
            if (!dayExist) {
                this.selectedDayModel = 1;
            }
        }
    }

    /* istanbul ignore next */
    getEffectiveYear() {
        if (this._minDateValue) {
            return this._minDateValue.getFullYear();
        } else {
            if (this.effectiveDate) {
                return this.effectiveDate.substr(this.effectiveDate.length - 4);
            } else {
                return new Date().getFullYear();
            }
        }
    }

    /* istanbul ignore next */
    generate(event) {
        // START : UFD-5734 : When user select date 31 Jan 2020 from calendar it didnât reflect in drop down date column get blank
        // UFD-5294 : Incorrect Date field for February month
        this.selectedMonthVal = event.getMonth() + 1;
        this.days = this.checkDaysInMonth();
        // END
        this.selectedYearModel = event.getFullYear();
        if (this.monthFullname) {
            let monthList = this.createMonthsList();
            this.selectedMonthModel = monthList[event.getMonth()];
        } else {
            let shortMonthList = this.createShortMonthsList();
            this.selectedMonthModel = shortMonthList[event.getMonth()];
        }
        this.selectedDayModel = event.getDate();
        this.onDateChange.emit({ 'event': event, 'fulldate': this.dateValue });
    }

    /* istanbul ignore next */
    getDateFromCalendar(event) {
        this.onDateChange.emit({ 'event': event });
    }
    /* istanbul ignore next */
    retrieveMonthNames(selectedIndex) {
        let i = 0;
        for (const month of Object.keys(this.monthNmArr)) {
            if (i === selectedIndex) {
                return this.monthNmArr[month];
            }
            i++;
        }
    }
    /* istanbul ignore next */
    public handleMonthIndex(selectedMonthModel) {
        let monthsName;
        if (this.domStorageFB.getItem('dateSelectorKey') !== null && this.domStorageFB.getItem('dateSelectorKey') !== '' && this.domStorageFB.getItem('dateSelectorKey') !== undefined) {
            this.dateSelectorMultiLanguage = JSON.parse(this.domStorageFB.getItem('dateSelectorKey'));
        }
        if (selectedMonthModel) {
            if (this.dateSelectorMultiLanguage) {
                monthsName = this.dateSelectorMultiLanguage.monthNames;
                let index = 0;
                for (const month of Object.keys(monthsName)) {
                    if (monthsName[month].trim().toLowerCase() === selectedMonthModel.trim().toLowerCase()) {
                        this.monthIndex = index;
                        break;
                    }
                    index++;
                }
            }
        }
        return this.monthIndex;
    }

}
